<nav class="navbar navbar-expand-lg navbar-dark">
  <div class="container-fluid">
    <!-- Logo -->
    <!-- <a class="navbar-brand fw-bold" href="#">
      <img src="assets/logos/amha/logo.svg" alt="AMHA Logo" class="navbar-logo" />
    </a> -->

    <!-- Toggle Sidebar Button -->
    <span class="material-icons-outlined toggle-icon" (click)="onToggleSidebar()" type="button" title="Toggle Sidebar">
      menu_open
    </span>

    <!-- Navbar Collapse -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarNav">
      
      <!-- Center Aligned Clinic Dropdown -->
      <ul class="navbar-nav mx-auto">
        <li class="nav-item d-flex align-items-center">
          <div style="width: 300px;" *ngIf="showClinicDropdown">
            <ng-select [items]="clinics" bindLabel="value" bindValue="id" 
              placeholder="Select Clinic" [clearable]="false"
              [(ngModel)]="selectedClinicId"
              [loading]="isClinicLoading"
              notFoundText="No clinics found"
              (change)="onClinicChange($event)">
            </ng-select>
          </div>
        </li>
      </ul>

      <ul class="navbar-nav ms-auto">
        <!-- Notifications -->
        <li class="nav-item" ngbDropdown placement="bottom-end" autoClose="outside">
          <!-- Bell Icon -->
          <a class="nav-link position-relative notification" ngbDropdownToggle role="button">
            <span class="icon material-icons-outlined mt-2">notifications</span>
            <span class="position-absolute badge rounded-pill bg-danger">
              3
            </span>
          </a>

          <!-- Dropdown -->
          <div class="dropdown-menu dropdown-menu-end notification-dropdown" ngbDropdownMenu>
            <!-- Header -->
            <div class="dropdown-header d-flex justify-content-between align-items-center">
              <span class="note-title">Notifications</span>
              <span class="material-symbols-outlined close-icon">close</span>
            </div>

            <!-- Notification list -->
            <div class="notification-list">
              <div class="notification-item d-flex" *ngFor="let n of notifications">
                <div class="icon-wrapper" [ngClass]="n.type">
                  <span class="icon material-symbols-outlined">
                    {{ n.icon }}
                  </span>
                </div>

                <div class="content">
                  <p class="mb-1">
                    <strong>{{ n.user }}</strong>
                    {{ n.message }}
                    <strong>{{ n.patient }}</strong>
                  </p>
                  <small>{{ n.time }}</small>
                </div>
              </div>
            </div>
          </div>
        </li>


        <!-- User Menu -->
        <li class="nav-item dropdown ms-3" ngbDropdown autoClose="outside">
          <a class="nav-link dropdown-toggle d-flex align-items-center" ngbDropdownToggle role="button">
            <span class="user-initial">{{ getInitials() }}</span>

            <div>
              <span class="user-name d-block">{{ currentUserName || currentUserEmail }}</span>
              <span class="role">{{ getUserRole() }}</span>
            </div>
          </a>

          <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            <li>
              <a class="dropdown-item"  href="javascript:void(0)" (click)="profile()">
                <span class="icon material-symbols-outlined fs-20">person</span>
                <span class="dropdown-text">Profile</span>
              </a>
            </li>

            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">
                <span class="icon material-symbols-outlined">logout</span>
                <span class="dropdown-text">Logout</span>
              </a>
            </li>
          </ul>
        </li>

      </ul>
    </div>
  </div>
</nav>